import React from 'react'
import { useFormContext } from './form-context'
import { FormControlContextValue, FormControlProvider } from './form-control-context'

interface FormControlProps {
  children?: React.ReactNode
  name: string
  id?: string
  error?: string | React.ReactNode
  isDisabled?: boolean
  isInvalid?: boolean
  isRequired?: boolean
}

/**
 * Wrapper that provides a context for an input and its helper components.
 */
export const FormControl: React.FC<FormControlProps> = ({
  children,
  error,
  id,
  name,
  isDisabled,
  isInvalid,
  isRequired,
}) => {
  const formContext = useFormContext()
  const { formId } = formContext

  const contextValue: FormControlContextValue = {
    error,
    nameContext: name,
    idContext: id ?? `${formId}-${name}`,
    isDisabledContext: isDisabled,
    isInvalidContext: isInvalid,
    isRequiredContext: isRequired,
  }
  return <FormControlProvider value={contextValue}>{children}</FormControlProvider>
}
